import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import {
  CS,
  CY,
  DA,
  DE,
  EN,
  ES,
  FI,
  FR,
  IT,
  NB,
  NL,
  PL,
  PT,
  SV,
  ZH,
} from "./list-language";

function mapSourceLanguage(language: string): Record<string, string> {
  switch (language) {
    case "zh":
      return ZH;
    case "cs":
      return CS;
    case "da":
      return DA;
    case "nl":
      return NL;
    case "en":
      return EN;
    case "fi":
      return FI;
    case "fr":
      return FR;
    case "de":
      return DE;
    case "it":
      return IT;
    case "nb":
      return NB;
    case "pl":
      return PL;
    case "pt":
      return PT;
    case "es":
      return ES;
    case "sv":
      return SV;
    case "cy":
      return CY;
    default:
      return EN;
  }
}

const resources = {
  en: { translation: EN },
};

if (!window.i18nInstance) {
  window.i18nInstance = i18next.createInstance();
}
const newInstance = window.i18nInstance;

newInstance.use(initReactI18next).init({
  lng: "en", // if you're using a language detector, do not define the lng option
  debug: true,
  resources,
  react: {
    bindI18n: "languageChanged",
    bindI18nStore: "languageChanged",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
    useSuspense: true,
  },
});

export const setLanguageAndFormatTime = async (language: string) => {
  newInstance.init({
    lng: language,
    debug: false,
    fallbackLng: language,
    resources: {
      [language || ""]: {
        translation: mapSourceLanguage(language),
      },
    },
    react: {
      bindI18n: "languageChanged",
      bindI18nStore: "languageChanged",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
      useSuspense: true,
    },
  });
};

export default newInstance;
